<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <!-- <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-main style="padding:0">
          <v-text-field label="Titel der Umfrage" style="margin:10px;" v-model="inputText"></v-text-field>
      </v-main>

    </v-card> -->
    <v-card class="dialog">
      <div class="header">
        <v-text-field label="Titel der Umfrage" v-model="inputText"></v-text-field>
      </div>
      <v-switch
        v-model="customTitlePage"
        label="Benutzerdefinierte Startseite"
      ></v-switch>
      <div v-if="customTitlePage">
        Erstellen Sie hier den Inhalt Ihrer Titelseite:
        <vue-editor :editorOptions="editorSettings" v-model="description" />
      </div>
      <v-card-actions>
        <v-btn id="leftButton" text @click.stop="cancel">Abbrechen</v-btn>        
        <v-btn id="rightButton" elevation="0" @click.stop="agree" color="primary">Umfrage generieren</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor";
import ImageResize from "quill-image-resize-vue";
import { ImageDrop } from "quill-image-drop-module";

Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/imageDrop", ImageDrop);
export default {
  components:{
    VueEditor 
  },
  name: "FormDlg",
  data() {
    return {
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {}
        }
      },
      dialog: false,
      resolve: null,
      reject: null,
      inputText: "",
      title: null,
      description: "",
      customTitlePage: false,
      options: {
        width: 800,
        zIndex: 200,
      }
    };
  },

  methods: {
    open(title, options) {
      this.dialog = true;
      this.title = title;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      const surveyDetails ={
        title: this.inputText,
        description: this.description,
        customTitlePage: this.customTitlePage
      }
      this.resolve(surveyDetails);
      this.dialog = false;
    },
    cancel() {
      this.reject(false);
      this.dialog = false;
    }
  }
};
</script>